import { Api } from '../../../../services/interceptor';
import { QUERY_KEY } from '../../../../services/queryEndPoint';
import type {
  IDuplicatePlayerGroup,
  ILeaguePlayerCard,
  IMergePlayersRequest,
  IMergePreviewRequest,
  IMergePreviewResponse,
  IPagedResponse,
  PlayerPositionRole,
} from '../types/players';

/** Unwraps the backend's { success, message, data, errorCode } envelope. */
function unwrapData<T>(res: { data?: { data?: T } }): T {
  return res?.data?.data as T;
}

export interface ILeaguePlayersSearchParams {
  search?: string;
  tournamentId?: string;
  teamSnapshotId?: string;
  role?: PlayerPositionRole;
  page?: number;
  size?: number;
}

/** GET league/{leagueId}/players/search — Players-tab card grid. */
export async function fetchLeaguePlayers(
  leagueId: string,
  params: ILeaguePlayersSearchParams = {}
): Promise<IPagedResponse<ILeaguePlayerCard>> {
  const res = await Api.get(`${QUERY_KEY.leaguePlayersSearch}/${leagueId}/players/search`, {
    params: {
      page: 0,
      size: 20,
      ...params,
    },
  });
  return unwrapData<IPagedResponse<ILeaguePlayerCard>>(res);
}

/** GET league/duplicatePlayers/groups?leagueId= — LEAGUE_ADMIN only; callers must gate on canEditLeague. */
export async function fetchDuplicatePlayerGroups(leagueId: string): Promise<IDuplicatePlayerGroup[]> {
  const res = await Api.get(QUERY_KEY.leagueDuplicatePlayerGroups, { params: { leagueId } });
  return unwrapData<IDuplicatePlayerGroup[]>(res) ?? [];
}

/** POST league/duplicatePlayers/preview — non-mutating preview of a merge. LEAGUE_ADMIN only. */
export async function previewPlayerMerge(request: IMergePreviewRequest): Promise<IMergePreviewResponse> {
  const res = await Api.post(QUERY_KEY.leagueDuplicatePlayerPreview, request);
  return unwrapData<IMergePreviewResponse>(res);
}

/** POST league/duplicatePlayers/merge — merges mergePlayerIds into keepPlayerId. LEAGUE_ADMIN only. */
export async function mergeDuplicatePlayers(request: IMergePlayersRequest): Promise<string> {
  const res = await Api.post(QUERY_KEY.leagueDuplicatePlayerMerge, request);
  return unwrapData<string>(res);
}
